<template>
  <div class="c-swatch-selector w-full">
    <NPopover
      v-model:show="showPopover"
      :on-clickoutside="() => (showPopover = false)"
      placement="bottom"
      :show-arrow="false"
      trigger="manual"
      width="trigger"
    >
      <template #trigger>
        <div @click="showPopover = true">
          <div
            class="w-full h-8 cursor-pointer border-solid border-primary5 border-width-1 rounded-1"
            :class="{
              'transparent-pattern': modelValue === 'transparent',
            }"
            :style="{ backgroundColor: modelValue }"
          ></div>
        </div>
      </template>
      <template #default>
        <div class="flex flex-wrap gap-2 p-2">
          <div
            v-for="(color, index) in colors"
            :key="index"
            class="cursor-pointer border-solid border-width-1 rounded-2"
            :class="{
              'border-primary': color === modelValue,
              'border-primary5': color !== modelValue,
            }"
            @click="selectColor(color)"
          >
            <div class="w-6 h-6 ma-1 rounded-1" :style="{ backgroundColor: color }" />
          </div>
          <div
            v-if="includeTransparent"
            class="cursor-pointer border-solid border-width-1 rounded-2"
            :class="{
              'border-primary': 'transparent' === modelValue,
              'border-primary5': 'transparent' !== modelValue,
            }"
          >
            <div class="w-6 h-6 ma-1 rounded-1 transparent-pattern" @click="selectColor('transparent')" />
          </div>
        </div>
      </template>
    </NPopover>
  </div>
</template>

<script setup lang="ts">
import { NPopover } from 'naive-ui'
import { ref } from 'vue'

withDefaults(
  defineProps<{
    colors: string[]
    includeTransparent?: boolean
    modelValue?: string
  }>(),
  {
    includeTransparent: false,
    modelValue: 'transparent',
  },
)

const emit = defineEmits<{
  'update:modelValue': [c: string]
}>()

const showPopover = ref(false)

function selectColor(color: string) {
  emit('update:modelValue', color)
  showPopover.value = false
}
</script>

<style scoped>
.transparent-pattern {
  background: repeating-conic-gradient(#e7e7e7 0% 25%, transparent 0% 50%) 50% / 15px 15px;
}
</style>
